import * as React from "react";
import { Menu, DropdownItemProps, Button } from "semantic-ui-react";

import { CustomDropDownComponent } from "@/components/CustomDropDown";
import { FilterModal } from "./components/FiltersModal";
import "./styles.scss";
import { useMemo } from "react";
import { reviewStatusOptions } from "../options";
import { PostSearchQuery } from "@/services/bedrock";
import { useComplianceChecker } from "@/utils";

interface Props {
  query: PostSearchQuery;
  playerOptions?: DropdownItemProps[];
  segmentationOptions?: DropdownItemProps[];
  onUpdate: (query: PostSearchQuery) => void;
  onExport: () => void;
}

const ComplianceFiltersFC: React.FC<Props> = ({ query, playerOptions, segmentationOptions, onUpdate, onExport }) => {
  const { flaggedKeywords } = useComplianceChecker();
  const keywordsOptions: DropdownItemProps[] = useMemo(() => {
    return flaggedKeywords.map(keyword => {
      return {
        key: keyword.id,
        text: keyword.content,
        value: keyword.id,
      };
    });
  }, [flaggedKeywords]);

  const [displayAllFilters, setDisplayAllFilters] = React.useState<boolean | undefined>(undefined);
  const flaggedFilterOptions: DropdownItemProps[] = [{ key: "FLAG", text: "Flagged Posts Only", value: "FLAG" }];

  const activeFilters = React.useMemo(() => {
    let filtersCounter = 0;
    if (query.segmentationIds && query.segmentationIds.length > 0) filtersCounter += 1;
    if (query.playerIds && query.playerIds.length > 0) filtersCounter += 1;
    if (query.keyphraseIds && query.keyphraseIds.length > 0) filtersCounter += 1;
    if (query.reviewStatuses && query.reviewStatuses.length > 0) filtersCounter += 1;
    if (query.keyphrasePolicies && query.keyphrasePolicies.length > 0) filtersCounter += 1;
    if (query.from || query.until) filtersCounter += 1;
    if (query.mediaTypes && query.mediaTypes.length > 0) filtersCounter += 1;
    if (query.sourceTypes && query.sourceTypes.length > 0) filtersCounter += 1;

    return filtersCounter;
  }, [query]);

  return (
    <div>
      <Menu secondary className={"searchSetFilterMenu"}>
        {/* FILTER BY FLAGGED ... */}
        <CustomDropDownComponent
          defaultValue={query.keyphrasePolicies}
          options={flaggedFilterOptions}
          placeholder={"All Posts"}
          multiple={true}
          onChangeHandler={data => {
            onUpdate({
              ...query,
              keyphrasePolicies: data,
            });
          }}
        />

        {/* FILTER BY Review Status */}
        <CustomDropDownComponent
          defaultValue={query.reviewStatuses}
          options={reviewStatusOptions}
          placeholder={"Review Status"}
          multiple={true}
          onChangeHandler={data => {
            onUpdate({
              ...query,
              reviewStatuses: data,
            });
          }}
        />

        {/* FILTER BY PLAYER */}
        {playerOptions && playerOptions?.length > 0 && (
          <CustomDropDownComponent
            defaultValue={query.playerIds}
            options={playerOptions}
            placeholder={"Player"}
            multiple={true}
            onChangeHandler={data => {
              onUpdate({
                ...query,
                playerIds: data,
              });
            }}
          />
        )}

        <Menu.Item>
          <Button
            data-elm-id={"complianceAllFiltersBtn"}
            secondary
            className={"rounded allFiltersBtn"}
            icon
            onClick={() => setDisplayAllFilters(true)}
          >
            All Filters {activeFilters > 0 ? `(${activeFilters})` : ""}
          </Button>
        </Menu.Item>

        <Menu.Item>
          <Button
            data-elm-id={"complianceExportPlayersBtn"}
            className={"rounded complianceExportBtn"}
            secondary
            icon
            floated={"right"}
            onClick={onExport}
          >
            Export
          </Button>
        </Menu.Item>
      </Menu>

      <FilterModal
        open={!!displayAllFilters}
        query={query}
        onUpdate={q => {
          onUpdate(q);
          setDisplayAllFilters(false);
        }}
        keywordOptions={keywordsOptions}
        playerOptions={playerOptions}
        segmentationOptions={segmentationOptions}
        onClose={() => {
          setDisplayAllFilters(false);
        }}
      />
    </div>
  );
};

export const ComplianceFilters = ComplianceFiltersFC;
